import { render } from "./updateTeacherFaceView.vue?vue&type=template&id=1f115003&scoped=true"
import script from "./updateTeacherFaceView.vue?vue&type=script&lang=js"
export * from "./updateTeacherFaceView.vue?vue&type=script&lang=js"

import "./updateTeacherFaceView.vue?vue&type=style&index=0&id=1f115003&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f115003"]])

export default __exports__